import { render, staticRenderFns } from "./NotificationExamples.vue?vue&type=template&id=9595f600&scoped=true"
import script from "./NotificationExamples.vue?vue&type=script&lang=js"
export * from "./NotificationExamples.vue?vue&type=script&lang=js"
import style0 from "./NotificationExamples.vue?vue&type=style&index=0&id=9595f600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9595f600",
  null
  
)

export default component.exports